import { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/sections/Navbar";
import Footer from "@/components/sections/Footer";
import EstimateModal from "@/components/EstimateModal";
import useScrollReveal from "@/hooks/useScrollReveal";
import { events } from "@/lib/analytics";

export default function PageLayout({ children }) {
  const [modalOpen, setModalOpen] = useState(false);
  const { pathname, hash } = useLocation();
  useScrollReveal();

  // Send a GA4 page_view on every SPA route change
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname + hash,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname, hash]);

  // Global tel: click tracker — catches every phone link on every page
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest("a[href^='tel:']");
      if (a) events.phoneCall();
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  // Scroll to top on route change (unless there's a hash)
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(
          () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
          50
        );
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  useEffect(() => {
    document.body.style.overflow = modalOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [modalOpen]);

  const openEstimate = useCallback(() => {
    events.estimateModalOpen();
    setModalOpen(true);
  }, []);

  return (
    <>
      <Navbar onOpenEstimate={openEstimate} />
      {typeof children === "function" ? children({ openEstimate }) : children}
      <Footer />
      <EstimateModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        key={modalOpen ? "open" : "closed"}
      />
    </>
  );
}
